module.exports = __webpack_public_path__ + "media/coffee-preferences/brew_method_french_press-a404d5f1.png";